module.exports = {
      id: "clips-usage",
      viewBox: "0 0 110 68.6",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#clips-usage",
      toString: function () {
        return this.url;
      }
    }